module.exports = __webpack_public_path__ + "img/img10.c2f81b70.jpg";